/**
 * @fileoverview gRPC-Web generated client stub for com.mu.logistic.api
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!

import * as grpcWeb from 'grpc-web';

import { LogRequest, LogResponse } from './logs.api_pb';

export class LogServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string };
  options_: null | { [index: string]: string };

  constructor(hostname: string, credentials: null | { [index: string]: string }, options: null | { [index: string]: string }) {
    if (!options) options = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoAddLog = new grpcWeb.AbstractClientBase.MethodInfo(
    LogResponse,
    (request: LogRequest) => {
      return request.serializeBinary();
    },
    LogResponse.deserializeBinary
  );

  addLog(request: LogRequest, metadata: grpcWeb.Metadata | null, callback: (err: grpcWeb.Error, response: LogResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.LogService/AddLog',
      request,
      metadata || {},
      this.methodInfoAddLog,
      callback
    );
  }
}
